import React, { Component } from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import _ from 'lodash';
import SelectField from '../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import { Field } from 'redux-form';

const LOCALE_PREFIX = 'GB/components/FinancialInfo/FinancialInfo';

const MAX_NUMBER_OF_DEPENDENTS = 9;

function createNumberOfDependentsOptions() {
    const minToMaxNumbersList = [...new Array(MAX_NUMBER_OF_DEPENDENTS + 1).keys()];

    const options = minToMaxNumbersList.map((n) => ({
        id: n.toString(),
        displayText: n.toString()
    }));

    options[options.length - 1].displayText += '+';

    return options;
}

export class NumberOfDependents extends Component {
    static propTypes = {
        intl: intlShape.isRequired
    };

    render() {
        const { intl } = this.props;

        return (
            <Field
                id="numberOfDependents"
                name="numberOfDependents"
                component={SelectField}
                optionList={createNumberOfDependentsOptions()}
                required={true}
                label={intl.formatMessage({ id: `${LOCALE_PREFIX}.applyForBmlUK.numberOfDependents` })}
                placeholder={intl.formatMessage({ id: `${LOCALE_PREFIX}.applyForBmlUK.numberOfDependents` })}
                validate={[isEmpty(intl.formatMessage({ id: `${LOCALE_PREFIX}.applyForBmlUK.numberOfDependents-empty` }))]}
            />
        );
    }
}

export default connect()(injectIntl(NumberOfDependents));
